<template>
  <div class="home">
    <h1>aif2midi.com</h1>
    <p>Convert your aif file to midi</p>
    <Adsense
      data-ad-client="ca-pub-7862402993377528"
      data-ad-slot="5657948144">
    </Adsense>
    <MultipleFileUploader @upload="upload" />
    <AifFile v-for="file in files" :key="file.name" :file="file" />
  </div>
</template>

<script>
import AifFile from '@/components/AifFile.vue'
import MultipleFileUploader from '@/components/MultipleFileUploader.vue'

export default {
  name: 'Home',
  metaInfo: {
    title: 'Convert aif files to midi file',
    titleTemplate: '%s | aif2midi.com',
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'Convert your aif files to midi'}
    ]
  },
  components: {
    MultipleFileUploader,
    AifFile
  },
  methods: {
    upload (file) {
      this.files.push(file)
    }
  },
  data () {
    return {
      files: []
    }
  }
}
</script>
